import { render, staticRenderFns } from "./SetPasswordForm.vue?vue&type=template&id=70533b07&scoped=true&"
import script from "./SetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./SetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./SetPasswordForm.vue?vue&type=style&index=0&id=70533b07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70533b07",
  null
  
)

export default component.exports